import { apiFetch } from '../helpers'


export const getCourses = () => apiFetch('/learners/courses/')
